import { c as _c } from "react/compiler-runtime";
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from './../fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {
  [key: string]: unknown;
}> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends {
  [key: string]: unknown;
}, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  Date: {
    input: unknown;
    output: unknown;
  };
  DateTime: {
    input: unknown;
    output: unknown;
  };
};
export type AccountUpgradePromoPanel = Document & {
  __typename?: 'AccountUpgradePromoPanel';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** CTA button text - not shown if empty */
  cta?: Maybe<Scalars['String']['output']>;
  /** Description of the promo panel */
  description?: Maybe<Scalars['String']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
  /** Promo source string of the promo panel */
  promoSource?: Maybe<Scalars['String']['output']>;
  /** Promo sufix string of the promo panel (eg. mallkarta, tankovani, ...) */
  promoSufix?: Maybe<Scalars['String']['output']>;
  /** Subtitle (title in panel itself) of the promo panel */
  subTitle?: Maybe<Scalars['String']['output']>;
  /** Title of the promo panel */
  title?: Maybe<Scalars['String']['output']>;
};
export type AccountUpgradePromoPanelFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  cta?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  promoSource?: InputMaybe<StringFilter>;
  promoSufix?: InputMaybe<StringFilter>;
  subTitle?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};
export type AccountUpgradePromoPanelOrAffiliateEshopOrAffiliateEshopsListOrAffiliatePanelOrBannerOrCookiesOrEshopsOrFaqCategoryOrFaqQuestionOrFeaturedPartnersItemOrFeaturedPartnersListOrGcssCategoryOrGcssHomepageOrGcssProductOrJobsOrModalsOrPageBannerOrPageBannerButtonOrPageBannerHighlightOrPageMenuPromoBannerOrPressReleaseOrRegistrationPromoPageOrSeoImageOrStoryOrStoryPageOrTestimonialsOrTestimonialsListsOrWroteAboutUs = AccountUpgradePromoPanel | AffiliateEshop | AffiliateEshopsList | AffiliatePanel | Banner | Cookies | Eshops | FaqCategory | FaqQuestion | FeaturedPartnersItem | FeaturedPartnersList | GcssCategory | GcssHomepage | GcssProduct | Jobs | Modals | PageBanner | PageBannerButton | PageBannerHighlight | PageMenuPromoBanner | PressRelease | RegistrationPromoPage | SeoImage | Story | StoryPage | Testimonials | TestimonialsLists | WroteAboutUs;
export type AccountUpgradePromoPanelSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  cta?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  promoSource?: InputMaybe<SortOrder>;
  promoSufix?: InputMaybe<SortOrder>;
  subTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};
export type AffiliateEshop = Document & {
  __typename?: 'AffiliateEshop';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
  imageAlt?: Maybe<Scalars['String']['output']>;
  /** Link of the affiliate panel */
  link?: Maybe<Scalars['String']['output']>;
  /** Title of the affiliate panel */
  title?: Maybe<Scalars['String']['output']>;
};
export type AffiliateEshopFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  imageAlt?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};
export type AffiliateEshopSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  imageAlt?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};
export type AffiliateEshopsList = Document & {
  __typename?: 'AffiliateEshopsList';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  eshops?: Maybe<Array<Maybe<AffiliateEshop>>>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  pageSlug?: Maybe<Scalars['String']['output']>;
};
export type AffiliateEshopsListFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  pageSlug?: InputMaybe<StringFilter>;
};
export type AffiliateEshopsListSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  pageSlug?: InputMaybe<SortOrder>;
};
export type AffiliatePanel = Document & {
  __typename?: 'AffiliatePanel';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Creative of the affiliate panel (analytics purpose, should be uniq) */
  creative?: Maybe<Scalars['String']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
  /** Label (max 15 letters) placed above box. Only for light application list section. */
  label?: Maybe<Scalars['String']['output']>;
  labelColor?: Maybe<Scalars['String']['output']>;
  /** Link of the affiliate panel */
  link?: Maybe<Scalars['String']['output']>;
  /** Order of the affiliate panel (higher number has bigger priority, keep numbers under 100) */
  order?: Maybe<Scalars['Float']['output']>;
  /** Section of the affiliate panel */
  section?: Maybe<Scalars['String']['output']>;
  /** Title of the affiliate panel */
  title?: Maybe<Scalars['String']['output']>;
};
export type AffiliatePanelFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  creative?: InputMaybe<StringFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  label?: InputMaybe<StringFilter>;
  labelColor?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  order?: InputMaybe<FloatFilter>;
  section?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};
export type AffiliatePanelSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  creative?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  label?: InputMaybe<SortOrder>;
  labelColor?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  section?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};
export type Banner = Document & {
  __typename?: 'Banner';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Defines, where the banner will be displayed */
  bannerType?: Maybe<Scalars['String']['output']>;
  bannerUrTarget?: Maybe<Scalars['String']['output']>;
  /** Where a click on the banner should redirect to (absolute address for external links, relative address for internal links - e.g. /prehled-odmen) */
  bannerUrl?: Maybe<Scalars['String']['output']>;
  /** One-line benefit of the offer shown on this banner, e.g. "až 200 000 Kč, splátky od 1 000 Kč/měs.". This text is never displayed to customers on the banner - it is what the AI assistant says about the offer when it recommends it in a chat. */
  botDescription?: Maybe<Scalars['String']['output']>;
  /** Short name of the offer shown on this banner, e.g. "Skip Pay půjčka". This text is never displayed to customers on the banner - it is how the AI assistant names the offer when it recommends it in a chat. */
  botLabel?: Maybe<Scalars['String']['output']>;
  canApplyForRevolving?: Maybe<Scalars['Boolean']['output']>;
  desktopImage?: Maybe<Image>;
  hasPlusAccount?: Maybe<Scalars['Boolean']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  mobileImage?: Maybe<Image>;
  /** Priority of the banner */
  priority?: Maybe<Scalars['Float']['output']>;
  promoCreative?: Maybe<Scalars['String']['output']>;
  promoName?: Maybe<Scalars['String']['output']>;
  /** Determines who sees this banner based on the customer's current state. A banner without a slug is shown to everyone. A banner with a slug is shown only to customers that match that condition. Each slug must be used at most once in Sanity — two stories sharing the same slug will cause incorrect display. */
  slug?: Maybe<Scalars['String']['output']>;
};
export type BannerFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  bannerType?: InputMaybe<StringFilter>;
  bannerUrTarget?: InputMaybe<StringFilter>;
  bannerUrl?: InputMaybe<StringFilter>;
  botDescription?: InputMaybe<StringFilter>;
  botLabel?: InputMaybe<StringFilter>;
  canApplyForRevolving?: InputMaybe<BooleanFilter>;
  desktopImage?: InputMaybe<ImageFilter>;
  hasPlusAccount?: InputMaybe<BooleanFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  mobileImage?: InputMaybe<ImageFilter>;
  priority?: InputMaybe<FloatFilter>;
  promoCreative?: InputMaybe<StringFilter>;
  promoName?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
};
export type BannerSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  bannerType?: InputMaybe<SortOrder>;
  bannerUrTarget?: InputMaybe<SortOrder>;
  bannerUrl?: InputMaybe<SortOrder>;
  botDescription?: InputMaybe<SortOrder>;
  botLabel?: InputMaybe<SortOrder>;
  canApplyForRevolving?: InputMaybe<SortOrder>;
  desktopImage?: InputMaybe<ImageSorting>;
  hasPlusAccount?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  mobileImage?: InputMaybe<ImageSorting>;
  priority?: InputMaybe<SortOrder>;
  promoCreative?: InputMaybe<SortOrder>;
  promoName?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
};
export type Block = {
  __typename?: 'Block';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<Maybe<Span>>>;
  level?: Maybe<Scalars['Float']['output']>;
  listItem?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
};
export type BooleanFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the value is defined. */
  is_defined?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};
export type Cookies = Document & {
  __typename?: 'Cookies';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Category of the cookie */
  category?: Maybe<Scalars['String']['output']>;
  /** Description of the cookie */
  description?: Maybe<Scalars['String']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  /** Link of the cookie */
  link?: Maybe<Scalars['String']['output']>;
  /** Title of the cookie */
  title?: Maybe<Scalars['String']['output']>;
};
export type CookiesFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  category?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};
export type CookiesSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  category?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};
export type CrossDatasetReference = {
  __typename?: 'CrossDatasetReference';
  _dataset?: Maybe<Scalars['String']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  _projectId?: Maybe<Scalars['String']['output']>;
  _ref?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  _weak?: Maybe<Scalars['Boolean']['output']>;
};
export type CrossDatasetReferenceFilter = {
  _dataset?: InputMaybe<StringFilter>;
  _key?: InputMaybe<StringFilter>;
  _projectId?: InputMaybe<StringFilter>;
  _ref?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _weak?: InputMaybe<BooleanFilter>;
};
export type CrossDatasetReferenceSorting = {
  _dataset?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _projectId?: InputMaybe<SortOrder>;
  _ref?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _weak?: InputMaybe<SortOrder>;
};
export type DateFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Date']['input']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Date']['input']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** Checks if the value is defined. */
  is_defined?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Date']['input']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Date']['input']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Date']['input']>;
};
export type DatetimeFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the value is defined. */
  is_defined?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A Sanity document */
export type Document = {
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
};
export type DocumentFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
};
export type DocumentSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
};
export type Eshops = Document & {
  __typename?: 'Eshops';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** First content area for the eshop's page */
  contentArea1?: Maybe<Scalars['String']['output']>;
  /** Second content area for the eshop's page */
  contentArea2?: Maybe<Scalars['String']['output']>;
  /** Third content area for the eshop's page */
  contentArea3?: Maybe<Scalars['String']['output']>;
  /** Fourth content area for the eshop's page */
  contentArea4?: Maybe<Scalars['String']['output']>;
  /** Fifth content area for the eshop's page */
  contentArea5?: Maybe<Scalars['String']['output']>;
  contentImage1?: Maybe<SeoImage>;
  contentImage2?: Maybe<SeoImage>;
  contentImage3?: Maybe<SeoImage>;
  contentTable1?: Maybe<Table>;
  /** ID of the eshop in the API (Coupon API) */
  eshopApiId?: Maybe<Scalars['String']['output']>;
  heroImage?: Maybe<SeoImage>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<SeoImage>;
  /** real link to eshop, eg. https://www.kosik.cz/ */
  merchantLink?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pageSeoDescription?: Maybe<Scalars['String']['output']>;
  pageSeoTitle?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Slug>;
};
export type EshopsFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  contentArea1?: InputMaybe<StringFilter>;
  contentArea2?: InputMaybe<StringFilter>;
  contentArea3?: InputMaybe<StringFilter>;
  contentArea4?: InputMaybe<StringFilter>;
  contentArea5?: InputMaybe<StringFilter>;
  contentImage1?: InputMaybe<SeoImageFilter>;
  contentImage2?: InputMaybe<SeoImageFilter>;
  contentImage3?: InputMaybe<SeoImageFilter>;
  contentTable1?: InputMaybe<TableFilter>;
  eshopApiId?: InputMaybe<StringFilter>;
  heroImage?: InputMaybe<SeoImageFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  logo?: InputMaybe<SeoImageFilter>;
  merchantLink?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  pageSeoDescription?: InputMaybe<StringFilter>;
  pageSeoTitle?: InputMaybe<StringFilter>;
  slug?: InputMaybe<SlugFilter>;
};
export type EshopsSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  contentArea1?: InputMaybe<SortOrder>;
  contentArea2?: InputMaybe<SortOrder>;
  contentArea3?: InputMaybe<SortOrder>;
  contentArea4?: InputMaybe<SortOrder>;
  contentArea5?: InputMaybe<SortOrder>;
  contentImage1?: InputMaybe<SeoImageSorting>;
  contentImage2?: InputMaybe<SeoImageSorting>;
  contentImage3?: InputMaybe<SeoImageSorting>;
  contentTable1?: InputMaybe<TableSorting>;
  eshopApiId?: InputMaybe<SortOrder>;
  heroImage?: InputMaybe<SeoImageSorting>;
  i18nLang?: InputMaybe<SortOrder>;
  logo?: InputMaybe<SeoImageSorting>;
  merchantLink?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pageSeoDescription?: InputMaybe<SortOrder>;
  pageSeoTitle?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SlugSorting>;
};
export type FaqCategory = Document & {
  __typename?: 'FaqCategory';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Image>;
  name?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<Maybe<FaqQuestion>>>;
  slug?: Maybe<Slug>;
};
export type FaqCategoryFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  icon?: InputMaybe<ImageFilter>;
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<SlugFilter>;
};
export type FaqCategorySorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  icon?: InputMaybe<ImageSorting>;
  name?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SlugSorting>;
};
export type FaqQuestion = Document & {
  __typename?: 'FaqQuestion';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Description of the category */
  description?: Maybe<Scalars['String']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  /** Comma separated keywords for search */
  keywords?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Priority of the category (for display - bigger number = higher priority) */
  priority?: Maybe<Scalars['Float']['output']>;
  slug?: Maybe<Slug>;
};
export type FaqQuestionFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  keywords?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  priority?: InputMaybe<FloatFilter>;
  slug?: InputMaybe<SlugFilter>;
};
export type FaqQuestionSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  keywords?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SlugSorting>;
};
export type FeaturedPartnersItem = {
  __typename?: 'FeaturedPartnersItem';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Image>;
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};
export type FeaturedPartnersItemFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  file?: InputMaybe<ImageFilter>;
  link?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};
export type FeaturedPartnersItemSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  file?: InputMaybe<ImageSorting>;
  link?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};
export type FeaturedPartnersList = Document & {
  __typename?: 'FeaturedPartnersList';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<FeaturedPartnersItem>>>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};
export type FeaturedPartnersListFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};
export type FeaturedPartnersListSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};
export type File = {
  __typename?: 'File';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  asset?: Maybe<SanityFileAsset>;
  media?: Maybe<GlobalDocumentReference>;
};
export type FileFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  asset?: InputMaybe<SanityFileAssetFilter>;
  media?: InputMaybe<GlobalDocumentReferenceFilter>;
};
export type FileSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  media?: InputMaybe<GlobalDocumentReferenceSorting>;
};
export type FloatFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the value is defined. */
  is_defined?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Float']['input']>;
};
export type GcssCategory = Document & {
  __typename?: 'GcssCategory';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<SeoImage>;
  mappedCategory?: Maybe<Scalars['Float']['output']>;
};
export type GcssCategoryFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<SeoImageFilter>;
  mappedCategory?: InputMaybe<FloatFilter>;
};
export type GcssCategorySorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  image?: InputMaybe<SeoImageSorting>;
  mappedCategory?: InputMaybe<SortOrder>;
};
export type GcssHomepage = Document & {
  __typename?: 'GcssHomepage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  categories?: Maybe<Array<Maybe<GcssCategory>>>;
  eshops?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  products?: Maybe<Array<Maybe<GcssProduct>>>;
};
export type GcssHomepageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
};
export type GcssHomepageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
};
export type GcssProduct = Document & {
  __typename?: 'GcssProduct';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  image?: Maybe<SeoImage>;
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};
export type GcssProductFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  brand?: InputMaybe<StringFilter>;
  currency?: InputMaybe<StringFilter>;
  image?: InputMaybe<SeoImageFilter>;
  link?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  price?: InputMaybe<FloatFilter>;
};
export type GcssProductSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  brand?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  image?: InputMaybe<SeoImageSorting>;
  link?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
};
export type Geopoint = {
  __typename?: 'Geopoint';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};
export type GeopointFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  alt?: InputMaybe<FloatFilter>;
  lat?: InputMaybe<FloatFilter>;
  lng?: InputMaybe<FloatFilter>;
};
export type GeopointSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  alt?: InputMaybe<SortOrder>;
  lat?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
};
export type GlobalDocumentReference = {
  __typename?: 'GlobalDocumentReference';
  _key?: Maybe<Scalars['String']['output']>;
  _ref?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  _weak?: Maybe<Scalars['Boolean']['output']>;
};
export type GlobalDocumentReferenceFilter = {
  _key?: InputMaybe<StringFilter>;
  _ref?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _weak?: InputMaybe<BooleanFilter>;
};
export type GlobalDocumentReferenceSorting = {
  _key?: InputMaybe<SortOrder>;
  _ref?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _weak?: InputMaybe<SortOrder>;
};
export type IdFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Checks if the value matches the given word/words. */
  matches?: InputMaybe<Scalars['ID']['input']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['ID']['input']>;
  nin?: InputMaybe<Array<Scalars['ID']['input']>>;
};
export type Image = {
  __typename?: 'Image';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  asset?: Maybe<SanityImageAsset>;
  crop?: Maybe<SanityImageCrop>;
  hotspot?: Maybe<SanityImageHotspot>;
  media?: Maybe<GlobalDocumentReference>;
};
export type ImageFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  asset?: InputMaybe<SanityImageAssetFilter>;
  crop?: InputMaybe<SanityImageCropFilter>;
  hotspot?: InputMaybe<SanityImageHotspotFilter>;
  media?: InputMaybe<GlobalDocumentReferenceFilter>;
};
export type ImageSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  crop?: InputMaybe<SanityImageCropSorting>;
  hotspot?: InputMaybe<SanityImageHotspotSorting>;
  media?: InputMaybe<GlobalDocumentReferenceSorting>;
};
export type IntFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Checks if the value is defined. */
  is_defined?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Int']['input']>;
};
export type InternationalizedArrayReferenceValue = {
  __typename?: 'InternationalizedArrayReferenceValue';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<AccountUpgradePromoPanelOrAffiliateEshopOrAffiliateEshopsListOrAffiliatePanelOrBannerOrCookiesOrEshopsOrFaqCategoryOrFaqQuestionOrFeaturedPartnersItemOrFeaturedPartnersListOrGcssCategoryOrGcssHomepageOrGcssProductOrJobsOrModalsOrPageBannerOrPageBannerButtonOrPageBannerHighlightOrPageMenuPromoBannerOrPressReleaseOrRegistrationPromoPageOrSeoImageOrStoryOrStoryPageOrTestimonialsOrTestimonialsListsOrWroteAboutUs>;
};
export type InternationalizedArrayReferenceValueFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
};
export type InternationalizedArrayReferenceValueSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
};
export type Jobs = Document & {
  __typename?: 'Jobs';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Workplace address. */
  address?: Maybe<Scalars['String']['output']>;
  /** Short address for the job listing. */
  addressShort?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  /** Description of the job listing. */
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Scalars['String']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  legalRelationship?: Maybe<Scalars['String']['output']>;
  minimalEducation?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Jazykové znalosti jako "Čeština (základní)", "Čeština (mírně pokročilá)", "Čeština (středně pokročilá)", "Čeština (pokročilá)", "Čeština (výborná)", "Angličtina (základní)", "Angličtina (mírně pokročilá)", "Angličtina (středně pokročilá)", "Angličtina (pokročilá)", "Angličtina (výborná)", "Jiné (definováno v inzerátu)" */
  requiredLanguageSkills?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Slug>;
};
export type JobsFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  address?: InputMaybe<StringFilter>;
  addressShort?: InputMaybe<StringFilter>;
  department?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  duration?: InputMaybe<StringFilter>;
  employment?: InputMaybe<StringFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  legalRelationship?: InputMaybe<StringFilter>;
  minimalEducation?: InputMaybe<StringFilter>;
  model?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  requiredLanguageSkills?: InputMaybe<StringFilter>;
  slug?: InputMaybe<SlugFilter>;
};
export type JobsSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  address?: InputMaybe<SortOrder>;
  addressShort?: InputMaybe<SortOrder>;
  department?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  employment?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  legalRelationship?: InputMaybe<SortOrder>;
  minimalEducation?: InputMaybe<SortOrder>;
  model?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  requiredLanguageSkills?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SlugSorting>;
};
export type Modals = Document & {
  __typename?: 'Modals';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  /** URL for the call-to-action button. */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Text for the call-to-action button. */
  ctaText?: Maybe<Scalars['String']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
  /** Unique identifier for this modal. Use this to filter or select a specific modal in your consumer. */
  modalId?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};
export type ModalsFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  content?: InputMaybe<StringFilter>;
  ctaLink?: InputMaybe<StringFilter>;
  ctaText?: InputMaybe<StringFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  modalId?: InputMaybe<StringFilter>;
  subtitle?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};
export type ModalsSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  ctaLink?: InputMaybe<SortOrder>;
  ctaText?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  modalId?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};
export type PageBanner = Document & {
  __typename?: 'PageBanner';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  buttons?: Maybe<Array<Maybe<PageBannerButton>>>;
  highlights?: Maybe<Array<Maybe<PageBannerHighlight>>>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
  /** The alt attribute in the img tag is used to provide alternative text for the image. */
  imageAlt?: Maybe<Scalars['String']['output']>;
  /** Defines, where the banner will be displayed */
  pageSlug?: Maybe<Scalars['String']['output']>;
  /** Promo source string of the promo. It works only on card, xmas, deferred-payment, spring-offer pages. */
  promoSource?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Select banner type. List of types is here: https://www.figma.com/file/TG5NzODcK0ghrIuj6CqEUf/Nov%C3%BD-web-%E2%80%93-2023?type=design&node-id=14091-193738&mode=dev */
  type?: Maybe<Scalars['String']['output']>;
  /** Video that plays in the modal. Video ID get from youtube video url: for example https://www.youtube.com/watch?v=HFqKn9V5krE is the ID HFqKn9V5krE. Or if you click share, then from the url https://youtu.be/HFqKn9V5krE?si=jZGZfwyxPtT7H8ac it's HFqKn9V5krE */
  videoId?: Maybe<Scalars['String']['output']>;
};
export type PageBannerButton = {
  __typename?: 'PageBannerButton';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};
export type PageBannerButtonFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  target?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  variant?: InputMaybe<StringFilter>;
};
export type PageBannerButtonSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  target?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  variant?: InputMaybe<SortOrder>;
};
export type PageBannerFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  imageAlt?: InputMaybe<StringFilter>;
  pageSlug?: InputMaybe<StringFilter>;
  promoSource?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  videoId?: InputMaybe<StringFilter>;
};
export type PageBannerHighlight = {
  __typename?: 'PageBannerHighlight';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};
export type PageBannerHighlightFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};
export type PageBannerHighlightSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  text?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};
export type PageBannerSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  imageAlt?: InputMaybe<SortOrder>;
  pageSlug?: InputMaybe<SortOrder>;
  promoSource?: InputMaybe<SortOrder>;
  text?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  videoId?: InputMaybe<SortOrder>;
};
export type PageMenuPromoBanner = Document & {
  __typename?: 'PageMenuPromoBanner';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
  /** Link of the promo banner */
  path?: Maybe<Scalars['String']['output']>;
  /** Defines, where the banner will be displayed */
  sectionId?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};
export type PageMenuPromoBannerFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  path?: InputMaybe<StringFilter>;
  sectionId?: InputMaybe<StringFilter>;
  target?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};
export type PageMenuPromoBannerSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  path?: InputMaybe<SortOrder>;
  sectionId?: InputMaybe<SortOrder>;
  target?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};
export type PressRelease = Document & {
  __typename?: 'PressRelease';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Check this box if you want to display this press release in the About Us section. */
  aboutUsSection?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<File>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  perex?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Slug>;
  text?: Maybe<Scalars['String']['output']>;
};
export type PressReleaseFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  aboutUsSection?: InputMaybe<BooleanFilter>;
  date?: InputMaybe<DatetimeFilter>;
  file?: InputMaybe<FileFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  perex?: InputMaybe<StringFilter>;
  slug?: InputMaybe<SlugFilter>;
  text?: InputMaybe<StringFilter>;
};
export type PressReleaseSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  aboutUsSection?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  file?: InputMaybe<FileSorting>;
  i18nLang?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  perex?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SlugSorting>;
  text?: InputMaybe<SortOrder>;
};
export type RegistrationPromoPage = Document & {
  __typename?: 'RegistrationPromoPage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
  /** Promo source string of the promo panel */
  promoSource?: Maybe<Scalars['String']['output']>;
  /** Title, that is displayed in promo panel */
  promoTitle?: Maybe<Scalars['String']['output']>;
  /** Subtitle of the page */
  subTitle?: Maybe<Scalars['String']['output']>;
  /** Title of the page */
  title?: Maybe<Scalars['String']['output']>;
};
export type RegistrationPromoPageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  promoSource?: InputMaybe<StringFilter>;
  promoTitle?: InputMaybe<StringFilter>;
  subTitle?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};
export type RegistrationPromoPageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  promoSource?: InputMaybe<SortOrder>;
  promoTitle?: InputMaybe<SortOrder>;
  subTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};
export type RootQuery = {
  __typename?: 'RootQuery';
  AccountUpgradePromoPanel?: Maybe<AccountUpgradePromoPanel>;
  AffiliateEshop?: Maybe<AffiliateEshop>;
  AffiliateEshopsList?: Maybe<AffiliateEshopsList>;
  AffiliatePanel?: Maybe<AffiliatePanel>;
  Banner?: Maybe<Banner>;
  Cookies?: Maybe<Cookies>;
  Document?: Maybe<Document>;
  Eshops?: Maybe<Eshops>;
  FaqCategory?: Maybe<FaqCategory>;
  FaqQuestion?: Maybe<FaqQuestion>;
  FeaturedPartnersList?: Maybe<FeaturedPartnersList>;
  GcssCategory?: Maybe<GcssCategory>;
  GcssHomepage?: Maybe<GcssHomepage>;
  GcssProduct?: Maybe<GcssProduct>;
  Jobs?: Maybe<Jobs>;
  Modals?: Maybe<Modals>;
  PageBanner?: Maybe<PageBanner>;
  PageMenuPromoBanner?: Maybe<PageMenuPromoBanner>;
  PressRelease?: Maybe<PressRelease>;
  RegistrationPromoPage?: Maybe<RegistrationPromoPage>;
  SanityFileAsset?: Maybe<SanityFileAsset>;
  SanityImageAsset?: Maybe<SanityImageAsset>;
  Story?: Maybe<Story>;
  StoryPage?: Maybe<StoryPage>;
  Testimonials?: Maybe<Testimonials>;
  TestimonialsLists?: Maybe<TestimonialsLists>;
  TranslationMetadata?: Maybe<TranslationMetadata>;
  WroteAboutUs?: Maybe<WroteAboutUs>;
  allAccountUpgradePromoPanel: Array<AccountUpgradePromoPanel>;
  allAffiliateEshop: Array<AffiliateEshop>;
  allAffiliateEshopsList: Array<AffiliateEshopsList>;
  allAffiliatePanel: Array<AffiliatePanel>;
  allBanner: Array<Banner>;
  allCookies: Array<Cookies>;
  allDocument: Array<Document>;
  allEshops: Array<Eshops>;
  allFaqCategory: Array<FaqCategory>;
  allFaqQuestion: Array<FaqQuestion>;
  allFeaturedPartnersList: Array<FeaturedPartnersList>;
  allGcssCategory: Array<GcssCategory>;
  allGcssHomepage: Array<GcssHomepage>;
  allGcssProduct: Array<GcssProduct>;
  allJobs: Array<Jobs>;
  allModals: Array<Modals>;
  allPageBanner: Array<PageBanner>;
  allPageMenuPromoBanner: Array<PageMenuPromoBanner>;
  allPressRelease: Array<PressRelease>;
  allRegistrationPromoPage: Array<RegistrationPromoPage>;
  allSanityFileAsset: Array<SanityFileAsset>;
  allSanityImageAsset: Array<SanityImageAsset>;
  allStory: Array<Story>;
  allStoryPage: Array<StoryPage>;
  allTestimonials: Array<Testimonials>;
  allTestimonialsLists: Array<TestimonialsLists>;
  allTranslationMetadata: Array<TranslationMetadata>;
  allWroteAboutUs: Array<WroteAboutUs>;
};
export type RootQueryAccountUpgradePromoPanelArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryAffiliateEshopArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryAffiliateEshopsListArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryAffiliatePanelArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryBannerArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryCookiesArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryDocumentArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryEshopsArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryFaqCategoryArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryFaqQuestionArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryFeaturedPartnersListArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryGcssCategoryArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryGcssHomepageArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryGcssProductArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryJobsArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryModalsArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryPageBannerArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryPageMenuPromoBannerArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryPressReleaseArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryRegistrationPromoPageArgs = {
  id: Scalars['ID']['input'];
};
export type RootQuerySanityFileAssetArgs = {
  id: Scalars['ID']['input'];
};
export type RootQuerySanityImageAssetArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryStoryArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryStoryPageArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryTestimonialsArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryTestimonialsListsArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryTranslationMetadataArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryWroteAboutUsArgs = {
  id: Scalars['ID']['input'];
};
export type RootQueryAllAccountUpgradePromoPanelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AccountUpgradePromoPanelSorting>>;
  where?: InputMaybe<AccountUpgradePromoPanelFilter>;
};
export type RootQueryAllAffiliateEshopArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AffiliateEshopSorting>>;
  where?: InputMaybe<AffiliateEshopFilter>;
};
export type RootQueryAllAffiliateEshopsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AffiliateEshopsListSorting>>;
  where?: InputMaybe<AffiliateEshopsListFilter>;
};
export type RootQueryAllAffiliatePanelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AffiliatePanelSorting>>;
  where?: InputMaybe<AffiliatePanelFilter>;
};
export type RootQueryAllBannerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BannerSorting>>;
  where?: InputMaybe<BannerFilter>;
};
export type RootQueryAllCookiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CookiesSorting>>;
  where?: InputMaybe<CookiesFilter>;
};
export type RootQueryAllDocumentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentSorting>>;
  where?: InputMaybe<DocumentFilter>;
};
export type RootQueryAllEshopsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EshopsSorting>>;
  where?: InputMaybe<EshopsFilter>;
};
export type RootQueryAllFaqCategoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FaqCategorySorting>>;
  where?: InputMaybe<FaqCategoryFilter>;
};
export type RootQueryAllFaqQuestionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FaqQuestionSorting>>;
  where?: InputMaybe<FaqQuestionFilter>;
};
export type RootQueryAllFeaturedPartnersListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FeaturedPartnersListSorting>>;
  where?: InputMaybe<FeaturedPartnersListFilter>;
};
export type RootQueryAllGcssCategoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GcssCategorySorting>>;
  where?: InputMaybe<GcssCategoryFilter>;
};
export type RootQueryAllGcssHomepageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GcssHomepageSorting>>;
  where?: InputMaybe<GcssHomepageFilter>;
};
export type RootQueryAllGcssProductArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GcssProductSorting>>;
  where?: InputMaybe<GcssProductFilter>;
};
export type RootQueryAllJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<JobsSorting>>;
  where?: InputMaybe<JobsFilter>;
};
export type RootQueryAllModalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ModalsSorting>>;
  where?: InputMaybe<ModalsFilter>;
};
export type RootQueryAllPageBannerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PageBannerSorting>>;
  where?: InputMaybe<PageBannerFilter>;
};
export type RootQueryAllPageMenuPromoBannerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PageMenuPromoBannerSorting>>;
  where?: InputMaybe<PageMenuPromoBannerFilter>;
};
export type RootQueryAllPressReleaseArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PressReleaseSorting>>;
  where?: InputMaybe<PressReleaseFilter>;
};
export type RootQueryAllRegistrationPromoPageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RegistrationPromoPageSorting>>;
  where?: InputMaybe<RegistrationPromoPageFilter>;
};
export type RootQueryAllSanityFileAssetArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SanityFileAssetSorting>>;
  where?: InputMaybe<SanityFileAssetFilter>;
};
export type RootQueryAllSanityImageAssetArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SanityImageAssetSorting>>;
  where?: InputMaybe<SanityImageAssetFilter>;
};
export type RootQueryAllStoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<StorySorting>>;
  where?: InputMaybe<StoryFilter>;
};
export type RootQueryAllStoryPageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<StoryPageSorting>>;
  where?: InputMaybe<StoryPageFilter>;
};
export type RootQueryAllTestimonialsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TestimonialsSorting>>;
  where?: InputMaybe<TestimonialsFilter>;
};
export type RootQueryAllTestimonialsListsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TestimonialsListsSorting>>;
  where?: InputMaybe<TestimonialsListsFilter>;
};
export type RootQueryAllTranslationMetadataArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TranslationMetadataSorting>>;
  where?: InputMaybe<TranslationMetadataFilter>;
};
export type RootQueryAllWroteAboutUsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WroteAboutUsSorting>>;
  where?: InputMaybe<WroteAboutUsFilter>;
};
export type SanityAssetSourceData = {
  __typename?: 'SanityAssetSourceData';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  /** The unique ID for the asset within the originating source so you can programatically find back to it */
  id?: Maybe<Scalars['String']['output']>;
  /** A canonical name for the source this asset is originating from */
  name?: Maybe<Scalars['String']['output']>;
  /** A URL to find more information about this asset in the originating source */
  url?: Maybe<Scalars['String']['output']>;
};
export type SanityAssetSourceDataFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};
export type SanityAssetSourceDataSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};
export type SanityFileAsset = Document & {
  __typename?: 'SanityFileAsset';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  altText?: Maybe<Scalars['String']['output']>;
  assetId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  originalFilename?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  sha1hash?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<SanityAssetSourceData>;
  title?: Maybe<Scalars['String']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};
export type SanityFileAssetFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  altText?: InputMaybe<StringFilter>;
  assetId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  extension?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  mimeType?: InputMaybe<StringFilter>;
  originalFilename?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  sha1hash?: InputMaybe<StringFilter>;
  size?: InputMaybe<FloatFilter>;
  source?: InputMaybe<SanityAssetSourceDataFilter>;
  title?: InputMaybe<StringFilter>;
  uploadId?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};
export type SanityFileAssetSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  altText?: InputMaybe<SortOrder>;
  assetId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  extension?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  mimeType?: InputMaybe<SortOrder>;
  originalFilename?: InputMaybe<SortOrder>;
  path?: InputMaybe<SortOrder>;
  sha1hash?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  source?: InputMaybe<SanityAssetSourceDataSorting>;
  title?: InputMaybe<SortOrder>;
  uploadId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};
export type SanityImageAsset = Document & {
  __typename?: 'SanityImageAsset';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  altText?: Maybe<Scalars['String']['output']>;
  assetId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<SanityImageMetadata>;
  mimeType?: Maybe<Scalars['String']['output']>;
  originalFilename?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  sha1hash?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<SanityAssetSourceData>;
  title?: Maybe<Scalars['String']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};
export type SanityImageAssetFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  altText?: InputMaybe<StringFilter>;
  assetId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  extension?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<SanityImageMetadataFilter>;
  mimeType?: InputMaybe<StringFilter>;
  originalFilename?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  sha1hash?: InputMaybe<StringFilter>;
  size?: InputMaybe<FloatFilter>;
  source?: InputMaybe<SanityAssetSourceDataFilter>;
  title?: InputMaybe<StringFilter>;
  uploadId?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};
export type SanityImageAssetSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  altText?: InputMaybe<SortOrder>;
  assetId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  extension?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SanityImageMetadataSorting>;
  mimeType?: InputMaybe<SortOrder>;
  originalFilename?: InputMaybe<SortOrder>;
  path?: InputMaybe<SortOrder>;
  sha1hash?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  source?: InputMaybe<SanityAssetSourceDataSorting>;
  title?: InputMaybe<SortOrder>;
  uploadId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};
export type SanityImageCrop = {
  __typename?: 'SanityImageCrop';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  bottom?: Maybe<Scalars['Float']['output']>;
  left?: Maybe<Scalars['Float']['output']>;
  right?: Maybe<Scalars['Float']['output']>;
  top?: Maybe<Scalars['Float']['output']>;
};
export type SanityImageCropFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  bottom?: InputMaybe<FloatFilter>;
  left?: InputMaybe<FloatFilter>;
  right?: InputMaybe<FloatFilter>;
  top?: InputMaybe<FloatFilter>;
};
export type SanityImageCropSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  bottom?: InputMaybe<SortOrder>;
  left?: InputMaybe<SortOrder>;
  right?: InputMaybe<SortOrder>;
  top?: InputMaybe<SortOrder>;
};
export type SanityImageDimensions = {
  __typename?: 'SanityImageDimensions';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};
export type SanityImageDimensionsFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  aspectRatio?: InputMaybe<FloatFilter>;
  height?: InputMaybe<FloatFilter>;
  width?: InputMaybe<FloatFilter>;
};
export type SanityImageDimensionsSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  aspectRatio?: InputMaybe<SortOrder>;
  height?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};
export type SanityImageHotspot = {
  __typename?: 'SanityImageHotspot';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};
export type SanityImageHotspotFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  height?: InputMaybe<FloatFilter>;
  width?: InputMaybe<FloatFilter>;
  x?: InputMaybe<FloatFilter>;
  y?: InputMaybe<FloatFilter>;
};
export type SanityImageHotspotSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  height?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
  x?: InputMaybe<SortOrder>;
  y?: InputMaybe<SortOrder>;
};
export type SanityImageMetadata = {
  __typename?: 'SanityImageMetadata';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  blurHash?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<SanityImageDimensions>;
  hasAlpha?: Maybe<Scalars['Boolean']['output']>;
  isOpaque?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Geopoint>;
  lqip?: Maybe<Scalars['String']['output']>;
  palette?: Maybe<SanityImagePalette>;
};
export type SanityImageMetadataFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  blurHash?: InputMaybe<StringFilter>;
  dimensions?: InputMaybe<SanityImageDimensionsFilter>;
  hasAlpha?: InputMaybe<BooleanFilter>;
  isOpaque?: InputMaybe<BooleanFilter>;
  location?: InputMaybe<GeopointFilter>;
  lqip?: InputMaybe<StringFilter>;
  palette?: InputMaybe<SanityImagePaletteFilter>;
};
export type SanityImageMetadataSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  blurHash?: InputMaybe<SortOrder>;
  dimensions?: InputMaybe<SanityImageDimensionsSorting>;
  hasAlpha?: InputMaybe<SortOrder>;
  isOpaque?: InputMaybe<SortOrder>;
  location?: InputMaybe<GeopointSorting>;
  lqip?: InputMaybe<SortOrder>;
  palette?: InputMaybe<SanityImagePaletteSorting>;
};
export type SanityImagePalette = {
  __typename?: 'SanityImagePalette';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  darkMuted?: Maybe<SanityImagePaletteSwatch>;
  darkVibrant?: Maybe<SanityImagePaletteSwatch>;
  dominant?: Maybe<SanityImagePaletteSwatch>;
  lightMuted?: Maybe<SanityImagePaletteSwatch>;
  lightVibrant?: Maybe<SanityImagePaletteSwatch>;
  muted?: Maybe<SanityImagePaletteSwatch>;
  vibrant?: Maybe<SanityImagePaletteSwatch>;
};
export type SanityImagePaletteFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  darkMuted?: InputMaybe<SanityImagePaletteSwatchFilter>;
  darkVibrant?: InputMaybe<SanityImagePaletteSwatchFilter>;
  dominant?: InputMaybe<SanityImagePaletteSwatchFilter>;
  lightMuted?: InputMaybe<SanityImagePaletteSwatchFilter>;
  lightVibrant?: InputMaybe<SanityImagePaletteSwatchFilter>;
  muted?: InputMaybe<SanityImagePaletteSwatchFilter>;
  vibrant?: InputMaybe<SanityImagePaletteSwatchFilter>;
};
export type SanityImagePaletteSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  darkMuted?: InputMaybe<SanityImagePaletteSwatchSorting>;
  darkVibrant?: InputMaybe<SanityImagePaletteSwatchSorting>;
  dominant?: InputMaybe<SanityImagePaletteSwatchSorting>;
  lightMuted?: InputMaybe<SanityImagePaletteSwatchSorting>;
  lightVibrant?: InputMaybe<SanityImagePaletteSwatchSorting>;
  muted?: InputMaybe<SanityImagePaletteSwatchSorting>;
  vibrant?: InputMaybe<SanityImagePaletteSwatchSorting>;
};
export type SanityImagePaletteSwatch = {
  __typename?: 'SanityImagePaletteSwatch';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  background?: Maybe<Scalars['String']['output']>;
  foreground?: Maybe<Scalars['String']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};
export type SanityImagePaletteSwatchFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  background?: InputMaybe<StringFilter>;
  foreground?: InputMaybe<StringFilter>;
  population?: InputMaybe<FloatFilter>;
  title?: InputMaybe<StringFilter>;
};
export type SanityImagePaletteSwatchSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  background?: InputMaybe<SortOrder>;
  foreground?: InputMaybe<SortOrder>;
  population?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};
export type Sanity_DocumentFilter = {
  /** All documents that are drafts. */
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** All documents referencing the given document ID. */
  references?: InputMaybe<Scalars['ID']['input']>;
};
export type SeoImage = {
  __typename?: 'SeoImage';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  asset?: Maybe<SanityImageAsset>;
  crop?: Maybe<SanityImageCrop>;
  hotspot?: Maybe<SanityImageHotspot>;
  link?: Maybe<Scalars['String']['output']>;
  media?: Maybe<GlobalDocumentReference>;
};
export type SeoImageFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  alt?: InputMaybe<StringFilter>;
  asset?: InputMaybe<SanityImageAssetFilter>;
  crop?: InputMaybe<SanityImageCropFilter>;
  hotspot?: InputMaybe<SanityImageHotspotFilter>;
  link?: InputMaybe<StringFilter>;
  media?: InputMaybe<GlobalDocumentReferenceFilter>;
};
export type SeoImageSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  alt?: InputMaybe<SortOrder>;
  crop?: InputMaybe<SanityImageCropSorting>;
  hotspot?: InputMaybe<SanityImageHotspotSorting>;
  link?: InputMaybe<SortOrder>;
  media?: InputMaybe<GlobalDocumentReferenceSorting>;
};
export type Slug = {
  __typename?: 'Slug';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  current?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};
export type SlugFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  current?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
};
export type SlugSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  current?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
};
export enum SortOrder {
  /** Sorts on the value in ascending order. */
  Asc = 'ASC',
  /** Sorts on the value in descending order. */
  Desc = 'DESC',
}
export type Span = {
  __typename?: 'Span';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  marks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  text?: Maybe<Scalars['String']['output']>;
};
export type Story = Document & {
  __typename?: 'Story';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Is this story for users that can apply for Revolving only? */
  applyForRevolving?: Maybe<Scalars['String']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  /** Is this story for MAXI users only? */
  isPremiumUser?: Maybe<Scalars['String']['output']>;
  /** The name of the story */
  name?: Maybe<Scalars['String']['output']>;
  navigationTitle?: Maybe<Scalars['String']['output']>;
  pages?: Maybe<Array<Maybe<StoryPage>>>;
  preview?: Maybe<Image>;
  /** Determines who sees this story based on the customer's current state. A story with a slug is shown only to customers that match that condition — e.g. HAS_ACTIVE_DEFERRED_PAYMENT shows only to customers with an active deferred payment. A story without a slug is shown to everyone. Each slug must be used at most once in Sanity — two stories sharing the same slug will cause incorrect display. */
  slug?: Maybe<Scalars['String']['output']>;
  visibleTo?: Maybe<Scalars['DateTime']['output']>;
};
export type StoryFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  applyForRevolving?: InputMaybe<StringFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  isPremiumUser?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  navigationTitle?: InputMaybe<StringFilter>;
  preview?: InputMaybe<ImageFilter>;
  slug?: InputMaybe<StringFilter>;
  visibleTo?: InputMaybe<DatetimeFilter>;
};
export type StoryPage = Document & {
  __typename?: 'StoryPage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  bodyImage?: Maybe<Image>;
  /** Primary button link */
  buttonLink?: Maybe<Scalars['String']['output']>;
  /** Primary button text */
  buttonText?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Image>;
  contentVideo?: Maybe<File>;
  headline?: Maybe<Scalars['String']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Secondary button link */
  secondaryButtonLink?: Maybe<Scalars['String']['output']>;
  /** Secondary button text */
  secondaryButtonText?: Maybe<Scalars['String']['output']>;
  /** The type of the story page. */
  type?: Maybe<Scalars['String']['output']>;
};
export type StoryPageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  body?: InputMaybe<StringFilter>;
  bodyImage?: InputMaybe<ImageFilter>;
  buttonLink?: InputMaybe<StringFilter>;
  buttonText?: InputMaybe<StringFilter>;
  content?: InputMaybe<ImageFilter>;
  contentVideo?: InputMaybe<FileFilter>;
  headline?: InputMaybe<StringFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  secondaryButtonLink?: InputMaybe<StringFilter>;
  secondaryButtonText?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};
export type StoryPageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  body?: InputMaybe<SortOrder>;
  bodyImage?: InputMaybe<ImageSorting>;
  buttonLink?: InputMaybe<SortOrder>;
  buttonText?: InputMaybe<SortOrder>;
  content?: InputMaybe<ImageSorting>;
  contentVideo?: InputMaybe<FileSorting>;
  headline?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  secondaryButtonLink?: InputMaybe<SortOrder>;
  secondaryButtonText?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};
export type StorySorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  applyForRevolving?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  isPremiumUser?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  navigationTitle?: InputMaybe<SortOrder>;
  preview?: InputMaybe<ImageSorting>;
  slug?: InputMaybe<SortOrder>;
  visibleTo?: InputMaybe<SortOrder>;
};
export type StringFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Checks if the value is defined. */
  is_defined?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the value matches the given word/words. */
  matches?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
};
export type Table = {
  __typename?: 'Table';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Array<Maybe<TableRow>>>;
};
export type TableFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
};
export type TableRow = {
  __typename?: 'TableRow';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  cells?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};
export type TableRowFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
};
export type TableRowSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
};
export type TableSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
};
export type Testimonials = Document & {
  __typename?: 'Testimonials';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  job?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Image>;
  name?: Maybe<Scalars['String']['output']>;
  /** If you enter "hidden", the rating will be hidden */
  ratingStars?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};
export type TestimonialsFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  job?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  logo?: InputMaybe<ImageFilter>;
  name?: InputMaybe<StringFilter>;
  ratingStars?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};
export type TestimonialsLists = Document & {
  __typename?: 'TestimonialsLists';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  pageSlug?: Maybe<Scalars['String']['output']>;
  testimonials?: Maybe<Array<Maybe<Testimonials>>>;
};
export type TestimonialsListsFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  pageSlug?: InputMaybe<StringFilter>;
};
export type TestimonialsListsSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  pageSlug?: InputMaybe<SortOrder>;
};
export type TestimonialsSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  job?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  logo?: InputMaybe<ImageSorting>;
  name?: InputMaybe<SortOrder>;
  ratingStars?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
  text?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};
export type TranslationMetadata = Document & {
  __typename?: 'TranslationMetadata';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  schemaTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  translations?: Maybe<Array<Maybe<InternationalizedArrayReferenceValue>>>;
};
export type TranslationMetadataFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
};
export type TranslationMetadataSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
};
export type WroteAboutUs = Document & {
  __typename?: 'WroteAboutUs';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  i18nLang?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};
export type WroteAboutUsFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  date?: InputMaybe<DatetimeFilter>;
  i18nLang?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
};
export type WroteAboutUsSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  i18nLang?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
  text?: InputMaybe<SortOrder>;
};
export type GetPageBannerBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  i18nLang: Scalars['String']['input'];
}>;
export type GetPageBannerBySlugQuery = {
  __typename?: 'RootQuery';
  allPageBanner: Array<{
    __typename?: 'PageBanner';
    title?: string | null;
    text?: string | null;
    videoId?: string | null;
    type?: string | null;
    promoSource?: string | null;
    pageSlug?: string | null;
    imageAlt?: string | null;
    highlights?: Array<{
      __typename?: 'PageBannerHighlight';
      title?: string | null;
      text?: string | null;
    } | null> | null;
    buttons?: Array<{
      __typename?: 'PageBannerButton';
      title?: string | null;
      target?: string | null;
      variant?: string | null;
      url?: string | null;
    } | null> | null;
    image?: {
      __typename?: 'Image';
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
      } | null;
    } | null;
  }>;
};
export type GetTestimonialsBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  i18nLang: Scalars['String']['input'];
}>;
export type GetTestimonialsBySlugQuery = {
  __typename?: 'RootQuery';
  allTestimonialsLists: Array<{
    __typename?: 'TestimonialsLists';
    testimonials?: Array<{
      __typename?: 'Testimonials';
      name?: string | null;
      type?: string | null;
      job?: string | null;
      text?: string | null;
      source?: string | null;
      ratingStars?: string | null;
      link?: string | null;
      logo?: {
        __typename?: 'Image';
        asset?: {
          __typename?: 'SanityImageAsset';
          url?: string | null;
        } | null;
      } | null;
    } | null> | null;
  }>;
};
export type GetAffiliateEshopsListBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  i18nLang: Scalars['String']['input'];
}>;
export type GetAffiliateEshopsListBySlugQuery = {
  __typename?: 'RootQuery';
  allAffiliateEshopsList: Array<{
    __typename?: 'AffiliateEshopsList';
    eshops?: Array<{
      __typename?: 'AffiliateEshop';
      link?: string | null;
      imageAlt?: string | null;
      image?: {
        __typename?: 'Image';
        asset?: {
          __typename?: 'SanityImageAsset';
          url?: string | null;
        } | null;
      } | null;
    } | null> | null;
  }>;
};
export type GetCmsEshopsLogosQueryVariables = Exact<{
  merchantNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  i18nLang: Scalars['String']['input'];
}>;
export type GetCmsEshopsLogosQuery = {
  __typename?: 'RootQuery';
  allEshops: Array<{
    __typename?: 'Eshops';
    eshopApiId?: string | null;
    logo?: {
      __typename?: 'SeoImage';
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
      } | null;
    } | null;
    heroImage?: {
      __typename?: 'SeoImage';
      alt?: string | null;
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
      } | null;
    } | null;
    slug?: {
      __typename?: 'Slug';
      current?: string | null;
    } | null;
  }>;
};
export type GetAllEshopsSlugsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  i18nLang: Scalars['String']['input'];
}>;
export type GetAllEshopsSlugsQuery = {
  __typename?: 'RootQuery';
  allEshops: Array<{
    __typename?: 'Eshops';
    slug?: {
      __typename?: 'Slug';
      current?: string | null;
    } | null;
  }>;
};
export type GetEshopDetailQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  i18nLang: Scalars['String']['input'];
}>;
export type GetEshopDetailQuery = {
  __typename?: 'RootQuery';
  allEshops: Array<{
    __typename?: 'Eshops';
    name?: string | null;
    merchantLink?: string | null;
    eshopApiId?: string | null;
    pageSeoTitle?: string | null;
    pageSeoDescription?: string | null;
    contentArea1?: string | null;
    contentArea2?: string | null;
    contentArea3?: string | null;
    contentArea4?: string | null;
    contentArea5?: string | null;
    logo?: {
      __typename?: 'SeoImage';
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
      } | null;
    } | null;
    heroImage?: {
      __typename?: 'SeoImage';
      alt?: string | null;
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
      } | null;
    } | null;
    contentImage1?: {
      __typename?: 'SeoImage';
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
      } | null;
    } | null;
    contentTable1?: {
      __typename?: 'Table';
      rows?: Array<{
        __typename?: 'TableRow';
        cells?: Array<string | null> | null;
      } | null> | null;
    } | null;
    contentImage2?: {
      __typename?: 'SeoImage';
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
      } | null;
    } | null;
    contentImage3?: {
      __typename?: 'SeoImage';
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
      } | null;
    } | null;
  }>;
};
export type GetAllCookiesQueryVariables = Exact<{
  i18nLang: Scalars['String']['input'];
}>;
export type GetAllCookiesQuery = {
  __typename?: 'RootQuery';
  allCookies: Array<{
    __typename?: 'Cookies';
    title?: string | null;
    description?: string | null;
    category?: string | null;
    link?: string | null;
  }>;
};
export type GetGcssCategoryQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;
export type GetGcssCategoryQuery = {
  __typename?: 'RootQuery';
  allGcssCategory: Array<{
    __typename?: 'GcssCategory';
    mappedCategory?: number | null;
    description?: string | null;
    image?: {
      __typename?: 'SeoImage';
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
      } | null;
    } | null;
  }>;
};
export type GetGcssCategoriesAllQueryVariables = Exact<{
  [key: string]: never;
}>;
export type GetGcssCategoriesAllQuery = {
  __typename?: 'RootQuery';
  allGcssCategory: Array<{
    __typename?: 'GcssCategory';
    mappedCategory?: number | null;
    description?: string | null;
    image?: {
      __typename?: 'SeoImage';
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
      } | null;
    } | null;
  }>;
};
export type GetGcssMainpageQueryVariables = Exact<{
  [key: string]: never;
}>;
export type GetGcssMainpageQuery = {
  __typename?: 'RootQuery';
  allGcssHomepage: Array<{
    __typename?: 'GcssHomepage';
    eshops?: Array<string | null> | null;
    categories?: Array<{
      __typename?: 'GcssCategory';
      mappedCategory?: number | null;
      description?: string | null;
      image?: {
        __typename?: 'SeoImage';
        asset?: {
          __typename?: 'SanityImageAsset';
          url?: string | null;
        } | null;
      } | null;
    } | null> | null;
    products?: Array<{
      __typename?: 'GcssProduct';
      name?: string | null;
      price?: number | null;
      currency?: string | null;
      brand?: string | null;
      link?: string | null;
      image?: {
        __typename?: 'SeoImage';
        asset?: {
          __typename?: 'SanityImageAsset';
          url?: string | null;
        } | null;
      } | null;
    } | null> | null;
  }>;
};
export type GetAllPageMenuPromoBannersQueryVariables = Exact<{
  i18nLang: Scalars['String']['input'];
}>;
export type GetAllPageMenuPromoBannersQuery = {
  __typename?: 'RootQuery';
  allPageMenuPromoBanner: Array<{
    __typename?: 'PageMenuPromoBanner';
    title?: string | null;
    path?: string | null;
    target?: string | null;
    sectionId?: string | null;
    image?: {
      __typename?: 'Image';
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
      } | null;
    } | null;
  }>;
};
export type GetBannersQueryVariables = Exact<{
  i18nLang: Scalars['String']['input'];
}>;
export type GetBannersQuery = {
  __typename?: 'RootQuery';
  allBanner: Array<{
    __typename?: 'Banner';
    _createdAt?: unknown | null;
    _updatedAt?: unknown | null;
    i18nLang?: string | null;
    bannerType?: string | null;
    bannerUrTarget?: string | null;
    bannerUrl?: string | null;
    canApplyForRevolving?: boolean | null;
    hasPlusAccount?: boolean | null;
    promoCreative?: string | null;
    promoName?: string | null;
    botLabel?: string | null;
    botDescription?: string | null;
    priority?: number | null;
    slug?: string | null;
    desktopImage?: {
      __typename?: 'Image';
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
        metadata?: {
          __typename?: 'SanityImageMetadata';
          dimensions?: {
            __typename?: 'SanityImageDimensions';
            width?: number | null;
            height?: number | null;
          } | null;
        } | null;
      } | null;
    } | null;
    mobileImage?: {
      __typename?: 'Image';
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
        metadata?: {
          __typename?: 'SanityImageMetadata';
          dimensions?: {
            __typename?: 'SanityImageDimensions';
            width?: number | null;
            height?: number | null;
          } | null;
        } | null;
      } | null;
    } | null;
  }>;
};
export type GetJobListQueryVariables = Exact<{
  i18nLang: Scalars['String']['input'];
}>;
export type GetJobListQuery = {
  __typename?: 'RootQuery';
  allJobs: Array<{
    __typename?: 'Jobs';
    addressShort?: string | null;
    department?: string | null;
    name?: string | null;
    model?: string | null;
    slug?: {
      __typename?: 'Slug';
      current?: string | null;
    } | null;
  }>;
};
export type GetJobDetailQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  i18nLang: Scalars['String']['input'];
}>;
export type GetJobDetailQuery = {
  __typename?: 'RootQuery';
  allJobs: Array<{
    __typename?: 'Jobs';
    address?: string | null;
    addressShort?: string | null;
    department?: string | null;
    description?: string | null;
    duration?: string | null;
    employment?: string | null;
    legalRelationship?: string | null;
    minimalEducation?: string | null;
    requiredLanguageSkills?: string | null;
    name?: string | null;
    model?: string | null;
    slug?: {
      __typename?: 'Slug';
      current?: string | null;
    } | null;
  }>;
};
export type GetWroteAboutUsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  i18nLang: Scalars['String']['input'];
}>;
export type GetWroteAboutUsQuery = {
  __typename?: 'RootQuery';
  allWroteAboutUs: Array<{
    __typename?: 'WroteAboutUs';
    name?: string | null;
    text?: string | null;
    date?: unknown | null;
    source?: string | null;
    link?: string | null;
  }>;
};
export type GetFeaturedPartnersQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
  i18nLang?: InputMaybe<Scalars['String']['input']>;
}>;
export type GetFeaturedPartnersQuery = {
  __typename?: 'RootQuery';
  allFeaturedPartnersList: Array<{
    __typename?: 'FeaturedPartnersList';
    name?: string | null;
    type?: string | null;
    items?: Array<{
      __typename?: 'FeaturedPartnersItem';
      name?: string | null;
      link?: string | null;
      file?: {
        __typename?: 'Image';
        asset?: {
          __typename?: 'SanityImageAsset';
          url?: string | null;
          metadata?: {
            __typename?: 'SanityImageMetadata';
            dimensions?: {
              __typename?: 'SanityImageDimensions';
              width?: number | null;
              height?: number | null;
            } | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  }>;
};
export type GetNewestPressReleasesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  i18nLang: Scalars['String']['input'];
}>;
export type GetNewestPressReleasesQuery = {
  __typename?: 'RootQuery';
  allPressRelease: Array<{
    __typename?: 'PressRelease';
    date?: unknown | null;
    name?: string | null;
    perex?: string | null;
    slug?: {
      __typename?: 'Slug';
      current?: string | null;
    } | null;
  }>;
};
export type GetPressReleaseDetailQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  i18nLang: Scalars['String']['input'];
}>;
export type GetPressReleaseDetailQuery = {
  __typename?: 'RootQuery';
  allPressRelease: Array<{
    __typename?: 'PressRelease';
    date?: unknown | null;
    text?: string | null;
    aboutUsSection?: boolean | null;
    name?: string | null;
    perex?: string | null;
    file?: {
      __typename?: 'File';
      asset?: {
        __typename?: 'SanityFileAsset';
        url?: string | null;
        mimeType?: string | null;
      } | null;
    } | null;
    slug?: {
      __typename?: 'Slug';
      current?: string | null;
    } | null;
  }>;
};
export type GetFaqCategoriesQueryVariables = Exact<{
  i18nLang: Scalars['String']['input'];
}>;
export type GetFaqCategoriesQuery = {
  __typename?: 'RootQuery';
  allFaqCategory: Array<{
    __typename?: 'FaqCategory';
    name?: string | null;
    _id?: string | null;
    icon?: {
      __typename?: 'Image';
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
        metadata?: {
          __typename?: 'SanityImageMetadata';
          dimensions?: {
            __typename?: 'SanityImageDimensions';
            width?: number | null;
            height?: number | null;
          } | null;
        } | null;
      } | null;
    } | null;
    slug?: {
      __typename?: 'Slug';
      current?: string | null;
    } | null;
    questions?: Array<{
      __typename?: 'FaqQuestion';
      description?: string | null;
      keywords?: string | null;
      name?: string | null;
      slug?: {
        __typename?: 'Slug';
        current?: string | null;
      } | null;
    } | null> | null;
  }>;
};
export type GetAllFaqCategoriesWithQuestionsSlugsQueryVariables = Exact<{
  i18nLang: Scalars['String']['input'];
}>;
export type GetAllFaqCategoriesWithQuestionsSlugsQuery = {
  __typename?: 'RootQuery';
  allFaqCategory: Array<{
    __typename?: 'FaqCategory';
    slug?: {
      __typename?: 'Slug';
      current?: string | null;
    } | null;
    questions?: Array<{
      __typename?: 'FaqQuestion';
      slug?: {
        __typename?: 'Slug';
        current?: string | null;
      } | null;
    } | null> | null;
  }>;
};
export type GetFaqCategoryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  i18nLang: Scalars['String']['input'];
}>;
export type GetFaqCategoryQuery = {
  __typename?: 'RootQuery';
  allFaqCategory: Array<{
    __typename?: 'FaqCategory';
    name?: string | null;
    _id?: string | null;
    icon?: {
      __typename?: 'Image';
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
        metadata?: {
          __typename?: 'SanityImageMetadata';
          dimensions?: {
            __typename?: 'SanityImageDimensions';
            width?: number | null;
            height?: number | null;
          } | null;
        } | null;
      } | null;
    } | null;
    slug?: {
      __typename?: 'Slug';
      current?: string | null;
    } | null;
    questions?: Array<{
      __typename?: 'FaqQuestion';
      name?: string | null;
      slug?: {
        __typename?: 'Slug';
        current?: string | null;
      } | null;
    } | null> | null;
  }>;
};
export type GetFaqNextCategoriesQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  i18nLang: Scalars['String']['input'];
}>;
export type GetFaqNextCategoriesQuery = {
  __typename?: 'RootQuery';
  allFaqCategory: Array<{
    __typename?: 'FaqCategory';
    name?: string | null;
    _id?: string | null;
    icon?: {
      __typename?: 'Image';
      asset?: {
        __typename?: 'SanityImageAsset';
        url?: string | null;
        metadata?: {
          __typename?: 'SanityImageMetadata';
          dimensions?: {
            __typename?: 'SanityImageDimensions';
            width?: number | null;
            height?: number | null;
          } | null;
        } | null;
      } | null;
    } | null;
    slug?: {
      __typename?: 'Slug';
      current?: string | null;
    } | null;
    questions?: Array<{
      __typename?: 'FaqQuestion';
      name?: string | null;
      slug?: {
        __typename?: 'Slug';
        current?: string | null;
      } | null;
    } | null> | null;
  }>;
};
export type GetFaqItemQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  i18nLang: Scalars['String']['input'];
}>;
export type GetFaqItemQuery = {
  __typename?: 'RootQuery';
  allFaqQuestion: Array<{
    __typename?: 'FaqQuestion';
    name?: string | null;
    description?: string | null;
    keywords?: string | null;
    slug?: {
      __typename?: 'Slug';
      current?: string | null;
    } | null;
  }>;
};
export type GetFaqItemsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  i18nLang: Scalars['String']['input'];
}>;
export type GetFaqItemsQuery = {
  __typename?: 'RootQuery';
  allFaqQuestion: Array<{
    __typename?: 'FaqQuestion';
    name?: string | null;
    description?: string | null;
    keywords?: string | null;
    slug?: {
      __typename?: 'Slug';
      current?: string | null;
    } | null;
  }>;
};
export type GetTopQuestionsQueryVariables = Exact<{
  questionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  i18nLang: Scalars['String']['input'];
}>;
export type GetTopQuestionsQuery = {
  __typename?: 'RootQuery';
  allFaqQuestion: Array<{
    __typename?: 'FaqQuestion';
    name?: string | null;
    description?: string | null;
    slug?: {
      __typename?: 'Slug';
      current?: string | null;
    } | null;
  }>;
};
export const GetPageBannerBySlugDocument = `
    query GetPageBannerBySlug($slug: String!, $i18nLang: String!) {
  allPageBanner(
    where: {pageSlug: {eq: $slug}, i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    title
    text
    videoId
    type
    promoSource
    pageSlug
    highlights {
      title
      text
    }
    buttons {
      title
      target
      variant
      url
    }
    imageAlt
    image {
      ... on Image {
        asset {
          url
        }
      }
    }
    promoSource
  }
}
    `;
export const useGetPageBannerBySlugQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetPageBannerBySlug", variables];
    t1 = fetcher(GetPageBannerBySlugDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetPageBannerBySlugQuery.getKey = (variables: GetPageBannerBySlugQueryVariables) => ['GetPageBannerBySlug', variables];
useGetPageBannerBySlugQuery.fetcher = (variables: GetPageBannerBySlugQueryVariables, options?: RequestInit['headers']) => fetcher<GetPageBannerBySlugQuery, GetPageBannerBySlugQueryVariables>(GetPageBannerBySlugDocument, variables, options);
export const GetTestimonialsBySlugDocument = `
    query GetTestimonialsBySlug($slug: String!, $i18nLang: String!) {
  allTestimonialsLists(
    where: {pageSlug: {eq: $slug}, i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    testimonials {
      name
      type
      job
      text
      source
      ratingStars
      link
      logo {
        ... on Image {
          asset {
            url
          }
        }
      }
    }
  }
}
    `;
export const useGetTestimonialsBySlugQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetTestimonialsBySlug", variables];
    t1 = fetcher(GetTestimonialsBySlugDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetTestimonialsBySlugQuery.getKey = (variables: GetTestimonialsBySlugQueryVariables) => ['GetTestimonialsBySlug', variables];
useGetTestimonialsBySlugQuery.fetcher = (variables: GetTestimonialsBySlugQueryVariables, options?: RequestInit['headers']) => fetcher<GetTestimonialsBySlugQuery, GetTestimonialsBySlugQueryVariables>(GetTestimonialsBySlugDocument, variables, options);
export const GetAffiliateEshopsListBySlugDocument = `
    query GetAffiliateEshopsListBySlug($slug: String!, $i18nLang: String!) {
  allAffiliateEshopsList(
    where: {pageSlug: {eq: $slug}, i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    eshops {
      link
      imageAlt
      image {
        ... on Image {
          asset {
            url
          }
        }
      }
    }
  }
}
    `;
export const useGetAffiliateEshopsListBySlugQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetAffiliateEshopsListBySlug", variables];
    t1 = fetcher(GetAffiliateEshopsListBySlugDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetAffiliateEshopsListBySlugQuery.getKey = (variables: GetAffiliateEshopsListBySlugQueryVariables) => ['GetAffiliateEshopsListBySlug', variables];
useGetAffiliateEshopsListBySlugQuery.fetcher = (variables: GetAffiliateEshopsListBySlugQueryVariables, options?: RequestInit['headers']) => fetcher<GetAffiliateEshopsListBySlugQuery, GetAffiliateEshopsListBySlugQueryVariables>(GetAffiliateEshopsListBySlugDocument, variables, options);
export const GetCmsEshopsLogosDocument = `
    query GetCmsEshopsLogos($merchantNames: [String!], $i18nLang: String!) {
  allEshops(
    where: {eshopApiId: {in: $merchantNames}, i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    eshopApiId
    logo {
      ... on SeoImage {
        asset {
          url
        }
      }
    }
    heroImage {
      ... on SeoImage {
        alt
        asset {
          url
        }
      }
    }
    slug {
      current
    }
  }
}
    `;
export const useGetCmsEshopsLogosQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetCmsEshopsLogos", variables];
    t1 = fetcher(GetCmsEshopsLogosDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetCmsEshopsLogosQuery.getKey = (variables: GetCmsEshopsLogosQueryVariables) => ['GetCmsEshopsLogos', variables];
useGetCmsEshopsLogosQuery.fetcher = (variables: GetCmsEshopsLogosQueryVariables, options?: RequestInit['headers']) => fetcher<GetCmsEshopsLogosQuery, GetCmsEshopsLogosQueryVariables>(GetCmsEshopsLogosDocument, variables, options);
export const GetAllEshopsSlugsDocument = `
    query GetAllEshopsSlugs($offset: Int!, $i18nLang: String!) {
  allEshops(
    offset: $offset
    where: {i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    slug {
      current
    }
  }
}
    `;
export const useGetAllEshopsSlugsQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetAllEshopsSlugs", variables];
    t1 = fetcher(GetAllEshopsSlugsDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetAllEshopsSlugsQuery.getKey = (variables: GetAllEshopsSlugsQueryVariables) => ['GetAllEshopsSlugs', variables];
useGetAllEshopsSlugsQuery.fetcher = (variables: GetAllEshopsSlugsQueryVariables, options?: RequestInit['headers']) => fetcher<GetAllEshopsSlugsQuery, GetAllEshopsSlugsQueryVariables>(GetAllEshopsSlugsDocument, variables, options);
export const GetEshopDetailDocument = `
    query GetEshopDetail($slug: String!, $i18nLang: String!) {
  allEshops(
    where: {slug: {current: {eq: $slug}}, i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    name
    merchantLink
    eshopApiId
    pageSeoTitle
    pageSeoDescription
    logo {
      ... on SeoImage {
        asset {
          url
        }
      }
    }
    heroImage {
      ... on SeoImage {
        alt
        asset {
          url
        }
      }
    }
    contentArea1
    contentArea2
    contentImage1 {
      ... on SeoImage {
        asset {
          url
        }
      }
    }
    contentArea3
    contentTable1 {
      ... on Table {
        rows {
          cells
        }
      }
    }
    contentImage2 {
      ... on SeoImage {
        asset {
          url
        }
      }
    }
    contentArea4
    contentImage3 {
      ... on SeoImage {
        asset {
          url
        }
      }
    }
    contentArea5
  }
}
    `;
export const useGetEshopDetailQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetEshopDetail", variables];
    t1 = fetcher(GetEshopDetailDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetEshopDetailQuery.getKey = (variables: GetEshopDetailQueryVariables) => ['GetEshopDetail', variables];
useGetEshopDetailQuery.fetcher = (variables: GetEshopDetailQueryVariables, options?: RequestInit['headers']) => fetcher<GetEshopDetailQuery, GetEshopDetailQueryVariables>(GetEshopDetailDocument, variables, options);
export const GetAllCookiesDocument = `
    query GetAllCookies($i18nLang: String!) {
  allCookies(where: {i18nLang: {eq: $i18nLang}, _: {is_draft: false}}, limit: 100) {
    title
    description
    category
    link
  }
}
    `;
export const useGetAllCookiesQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetAllCookies", variables];
    t1 = fetcher(GetAllCookiesDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetAllCookiesQuery.getKey = (variables: GetAllCookiesQueryVariables) => ['GetAllCookies', variables];
useGetAllCookiesQuery.fetcher = (variables: GetAllCookiesQueryVariables, options?: RequestInit['headers']) => fetcher<GetAllCookiesQuery, GetAllCookiesQueryVariables>(GetAllCookiesDocument, variables, options);
export const GetGcssCategoryDocument = `
    query GetGcssCategory($id: Float!) {
  allGcssCategory(where: {mappedCategory: {eq: $id}, _: {is_draft: false}}) {
    mappedCategory
    description
    image {
      ... on SeoImage {
        asset {
          url
        }
      }
    }
  }
}
    `;
export const useGetGcssCategoryQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetGcssCategory", variables];
    t1 = fetcher(GetGcssCategoryDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetGcssCategoryQuery.getKey = (variables: GetGcssCategoryQueryVariables) => ['GetGcssCategory', variables];
useGetGcssCategoryQuery.fetcher = (variables: GetGcssCategoryQueryVariables, options?: RequestInit['headers']) => fetcher<GetGcssCategoryQuery, GetGcssCategoryQueryVariables>(GetGcssCategoryDocument, variables, options);
export const GetGcssCategoriesAllDocument = `
    query GetGcssCategoriesAll {
  allGcssCategory(where: {_: {is_draft: false}}) {
    mappedCategory
    description
    image {
      ... on SeoImage {
        asset {
          url
        }
      }
    }
  }
}
    `;
export const useGetGcssCategoriesAllQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = variables === undefined ? ["GetGcssCategoriesAll"] : ["GetGcssCategoriesAll", variables];
    t1 = fetcher(GetGcssCategoriesAllDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetGcssCategoriesAllQuery.getKey = (variables?: GetGcssCategoriesAllQueryVariables) => variables === undefined ? ['GetGcssCategoriesAll'] : ['GetGcssCategoriesAll', variables];
useGetGcssCategoriesAllQuery.fetcher = (variables?: GetGcssCategoriesAllQueryVariables, options?: RequestInit['headers']) => fetcher<GetGcssCategoriesAllQuery, GetGcssCategoriesAllQueryVariables>(GetGcssCategoriesAllDocument, variables, options);
export const GetGcssMainpageDocument = `
    query GetGcssMainpage {
  allGcssHomepage {
    categories {
      ... on GcssCategory {
        mappedCategory
        description
        image {
          ... on SeoImage {
            asset {
              url
            }
          }
        }
      }
    }
    products {
      ... on GcssProduct {
        name
        price
        currency
        brand
        image {
          ... on SeoImage {
            asset {
              url
            }
          }
        }
        link
      }
    }
    eshops
  }
}
    `;
export const useGetGcssMainpageQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = variables === undefined ? ["GetGcssMainpage"] : ["GetGcssMainpage", variables];
    t1 = fetcher(GetGcssMainpageDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetGcssMainpageQuery.getKey = (variables?: GetGcssMainpageQueryVariables) => variables === undefined ? ['GetGcssMainpage'] : ['GetGcssMainpage', variables];
useGetGcssMainpageQuery.fetcher = (variables?: GetGcssMainpageQueryVariables, options?: RequestInit['headers']) => fetcher<GetGcssMainpageQuery, GetGcssMainpageQueryVariables>(GetGcssMainpageDocument, variables, options);
export const GetAllPageMenuPromoBannersDocument = `
    query GetAllPageMenuPromoBanners($i18nLang: String!) {
  allPageMenuPromoBanner(
    where: {i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
    limit: 100
  ) {
    title
    path
    target
    sectionId
    image {
      ... on Image {
        asset {
          url
        }
      }
    }
  }
}
    `;
export const useGetAllPageMenuPromoBannersQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetAllPageMenuPromoBanners", variables];
    t1 = fetcher(GetAllPageMenuPromoBannersDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetAllPageMenuPromoBannersQuery.getKey = (variables: GetAllPageMenuPromoBannersQueryVariables) => ['GetAllPageMenuPromoBanners', variables];
useGetAllPageMenuPromoBannersQuery.fetcher = (variables: GetAllPageMenuPromoBannersQueryVariables, options?: RequestInit['headers']) => fetcher<GetAllPageMenuPromoBannersQuery, GetAllPageMenuPromoBannersQueryVariables>(GetAllPageMenuPromoBannersDocument, variables, options);
export const GetBannersDocument = `
    query GetBanners($i18nLang: String!) {
  allBanner(where: {i18nLang: {eq: $i18nLang}, _: {is_draft: false}}) {
    _createdAt
    _updatedAt
    i18nLang
    bannerType
    bannerUrTarget
    bannerUrl
    canApplyForRevolving
    desktopImage {
      ... on Image {
        asset {
          url
          metadata {
            dimensions {
              width
              height
            }
          }
        }
      }
    }
    hasPlusAccount
    i18nLang
    mobileImage {
      ... on Image {
        asset {
          url
          metadata {
            dimensions {
              width
              height
            }
          }
        }
      }
    }
    promoCreative
    promoName
    botLabel
    botDescription
    priority
    slug
  }
}
    `;
export const useGetBannersQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetBanners", variables];
    t1 = fetcher(GetBannersDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetBannersQuery.getKey = (variables: GetBannersQueryVariables) => ['GetBanners', variables];
useGetBannersQuery.fetcher = (variables: GetBannersQueryVariables, options?: RequestInit['headers']) => fetcher<GetBannersQuery, GetBannersQueryVariables>(GetBannersDocument, variables, options);
export const GetJobListDocument = `
    query GetJobList($i18nLang: String!) {
  allJobs(
    where: {i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
    sort: {_id: DESC}
  ) {
    slug {
      current
    }
    addressShort
    department
    name
    model
  }
}
    `;
export const useGetJobListQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetJobList", variables];
    t1 = fetcher(GetJobListDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetJobListQuery.getKey = (variables: GetJobListQueryVariables) => ['GetJobList', variables];
useGetJobListQuery.fetcher = (variables: GetJobListQueryVariables, options?: RequestInit['headers']) => fetcher<GetJobListQuery, GetJobListQueryVariables>(GetJobListDocument, variables, options);
export const GetJobDetailDocument = `
    query GetJobDetail($slug: String!, $i18nLang: String!) {
  allJobs(
    limit: 1
    where: {slug: {current: {eq: $slug}}, i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    slug {
      current
    }
    address
    addressShort
    department
    description
    duration
    employment
    legalRelationship
    minimalEducation
    requiredLanguageSkills
    name
    model
  }
}
    `;
export const useGetJobDetailQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetJobDetail", variables];
    t1 = fetcher(GetJobDetailDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetJobDetailQuery.getKey = (variables: GetJobDetailQueryVariables) => ['GetJobDetail', variables];
useGetJobDetailQuery.fetcher = (variables: GetJobDetailQueryVariables, options?: RequestInit['headers']) => fetcher<GetJobDetailQuery, GetJobDetailQueryVariables>(GetJobDetailDocument, variables, options);
export const GetWroteAboutUsDocument = `
    query GetWroteAboutUs($limit: Int, $i18nLang: String!) {
  allWroteAboutUs(
    limit: $limit
    sort: {date: DESC}
    where: {i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    name
    text
    date
    source
    link
  }
}
    `;
export const useGetWroteAboutUsQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetWroteAboutUs", variables];
    t1 = fetcher(GetWroteAboutUsDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetWroteAboutUsQuery.getKey = (variables: GetWroteAboutUsQueryVariables) => ['GetWroteAboutUs', variables];
useGetWroteAboutUsQuery.fetcher = (variables: GetWroteAboutUsQueryVariables, options?: RequestInit['headers']) => fetcher<GetWroteAboutUsQuery, GetWroteAboutUsQueryVariables>(GetWroteAboutUsDocument, variables, options);
export const GetFeaturedPartnersDocument = `
    query GetFeaturedPartners($type: String, $i18nLang: String) {
  allFeaturedPartnersList(
    where: {type: {eq: $type}, i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
    sort: {_id: DESC}
  ) {
    name
    type
    items {
      name
      link
      file {
        asset {
          url
          metadata {
            dimensions {
              width
              height
            }
          }
        }
      }
    }
  }
}
    `;
export const useGetFeaturedPartnersQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = variables === undefined ? ["GetFeaturedPartners"] : ["GetFeaturedPartners", variables];
    t1 = fetcher(GetFeaturedPartnersDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetFeaturedPartnersQuery.getKey = (variables?: GetFeaturedPartnersQueryVariables) => variables === undefined ? ['GetFeaturedPartners'] : ['GetFeaturedPartners', variables];
useGetFeaturedPartnersQuery.fetcher = (variables?: GetFeaturedPartnersQueryVariables, options?: RequestInit['headers']) => fetcher<GetFeaturedPartnersQuery, GetFeaturedPartnersQueryVariables>(GetFeaturedPartnersDocument, variables, options);
export const GetNewestPressReleasesDocument = `
    query GetNewestPressReleases($limit: Int, $offset: Int, $i18nLang: String!) {
  allPressRelease(
    limit: $limit
    offset: $offset
    sort: {date: DESC}
    where: {i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    date
    name
    slug {
      current
    }
    perex
  }
}
    `;
export const useGetNewestPressReleasesQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetNewestPressReleases", variables];
    t1 = fetcher(GetNewestPressReleasesDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetNewestPressReleasesQuery.getKey = (variables: GetNewestPressReleasesQueryVariables) => ['GetNewestPressReleases', variables];
useGetNewestPressReleasesQuery.fetcher = (variables: GetNewestPressReleasesQueryVariables, options?: RequestInit['headers']) => fetcher<GetNewestPressReleasesQuery, GetNewestPressReleasesQueryVariables>(GetNewestPressReleasesDocument, variables, options);
export const GetPressReleaseDetailDocument = `
    query GetPressReleaseDetail($slug: String!, $i18nLang: String!) {
  allPressRelease(
    limit: 1
    where: {i18nLang: {eq: $i18nLang}, slug: {current: {eq: $slug}}, _: {is_draft: false}}
  ) {
    date
    file {
      asset {
        url
        mimeType
      }
    }
    text
    aboutUsSection
    name
    slug {
      current
    }
    perex
  }
}
    `;
export const useGetPressReleaseDetailQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetPressReleaseDetail", variables];
    t1 = fetcher(GetPressReleaseDetailDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetPressReleaseDetailQuery.getKey = (variables: GetPressReleaseDetailQueryVariables) => ['GetPressReleaseDetail', variables];
useGetPressReleaseDetailQuery.fetcher = (variables: GetPressReleaseDetailQueryVariables, options?: RequestInit['headers']) => fetcher<GetPressReleaseDetailQuery, GetPressReleaseDetailQueryVariables>(GetPressReleaseDetailDocument, variables, options);
export const GetFaqCategoriesDocument = `
    query GetFaqCategories($i18nLang: String!) {
  allFaqCategory(
    sort: {name: ASC}
    where: {i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    name
    icon {
      asset {
        url
        metadata {
          dimensions {
            width
            height
          }
        }
      }
    }
    slug {
      current
    }
    _id
    questions {
      slug {
        current
      }
      description
      keywords
      name
    }
  }
}
    `;
export const useGetFaqCategoriesQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetFaqCategories", variables];
    t1 = fetcher(GetFaqCategoriesDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetFaqCategoriesQuery.getKey = (variables: GetFaqCategoriesQueryVariables) => ['GetFaqCategories', variables];
useGetFaqCategoriesQuery.fetcher = (variables: GetFaqCategoriesQueryVariables, options?: RequestInit['headers']) => fetcher<GetFaqCategoriesQuery, GetFaqCategoriesQueryVariables>(GetFaqCategoriesDocument, variables, options);
export const GetAllFaqCategoriesWithQuestionsSlugsDocument = `
    query GetAllFaqCategoriesWithQuestionsSlugs($i18nLang: String!) {
  allFaqCategory(
    sort: {name: ASC}
    where: {i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    slug {
      current
    }
    questions {
      slug {
        current
      }
    }
  }
}
    `;
export const useGetAllFaqCategoriesWithQuestionsSlugsQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetAllFaqCategoriesWithQuestionsSlugs", variables];
    t1 = fetcher(GetAllFaqCategoriesWithQuestionsSlugsDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetAllFaqCategoriesWithQuestionsSlugsQuery.getKey = (variables: GetAllFaqCategoriesWithQuestionsSlugsQueryVariables) => ['GetAllFaqCategoriesWithQuestionsSlugs', variables];
useGetAllFaqCategoriesWithQuestionsSlugsQuery.fetcher = (variables: GetAllFaqCategoriesWithQuestionsSlugsQueryVariables, options?: RequestInit['headers']) => fetcher<GetAllFaqCategoriesWithQuestionsSlugsQuery, GetAllFaqCategoriesWithQuestionsSlugsQueryVariables>(GetAllFaqCategoriesWithQuestionsSlugsDocument, variables, options);
export const GetFaqCategoryDocument = `
    query GetFaqCategory($slug: String!, $i18nLang: String!) {
  allFaqCategory(
    limit: 1
    where: {slug: {current: {eq: $slug}}, i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    name
    icon {
      asset {
        url
        metadata {
          dimensions {
            width
            height
          }
        }
      }
    }
    slug {
      current
    }
    _id
    questions {
      name
      slug {
        current
      }
    }
  }
}
    `;
export const useGetFaqCategoryQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetFaqCategory", variables];
    t1 = fetcher(GetFaqCategoryDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetFaqCategoryQuery.getKey = (variables: GetFaqCategoryQueryVariables) => ['GetFaqCategory', variables];
useGetFaqCategoryQuery.fetcher = (variables: GetFaqCategoryQueryVariables, options?: RequestInit['headers']) => fetcher<GetFaqCategoryQuery, GetFaqCategoryQueryVariables>(GetFaqCategoryDocument, variables, options);
export const GetFaqNextCategoriesDocument = `
    query GetFaqNextCategories($ids: [ID!]!, $i18nLang: String!) {
  allFaqCategory(
    limit: 4
    where: {_id: {in: $ids}, i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    name
    icon {
      asset {
        url
        metadata {
          dimensions {
            width
            height
          }
        }
      }
    }
    slug {
      current
    }
    _id
    questions {
      name
      slug {
        current
      }
    }
  }
}
    `;
export const useGetFaqNextCategoriesQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetFaqNextCategories", variables];
    t1 = fetcher(GetFaqNextCategoriesDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetFaqNextCategoriesQuery.getKey = (variables: GetFaqNextCategoriesQueryVariables) => ['GetFaqNextCategories', variables];
useGetFaqNextCategoriesQuery.fetcher = (variables: GetFaqNextCategoriesQueryVariables, options?: RequestInit['headers']) => fetcher<GetFaqNextCategoriesQuery, GetFaqNextCategoriesQueryVariables>(GetFaqNextCategoriesDocument, variables, options);
export const GetFaqItemDocument = `
    query GetFaqItem($slug: String!, $i18nLang: String!) {
  allFaqQuestion(
    limit: 1
    where: {slug: {current: {eq: $slug}}, i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    name
    description
    slug {
      current
    }
    keywords
  }
}
    `;
export const useGetFaqItemQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetFaqItem", variables];
    t1 = fetcher(GetFaqItemDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetFaqItemQuery.getKey = (variables: GetFaqItemQueryVariables) => ['GetFaqItem', variables];
useGetFaqItemQuery.fetcher = (variables: GetFaqItemQueryVariables, options?: RequestInit['headers']) => fetcher<GetFaqItemQuery, GetFaqItemQueryVariables>(GetFaqItemDocument, variables, options);
export const GetFaqItemsDocument = `
    query GetFaqItems($offset: Int!, $i18nLang: String!) {
  allFaqQuestion(
    offset: $offset
    where: {i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
  ) {
    name
    slug {
      current
    }
    description
    keywords
  }
}
    `;
export const useGetFaqItemsQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetFaqItems", variables];
    t1 = fetcher(GetFaqItemsDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetFaqItemsQuery.getKey = (variables: GetFaqItemsQueryVariables) => ['GetFaqItems', variables];
useGetFaqItemsQuery.fetcher = (variables: GetFaqItemsQueryVariables, options?: RequestInit['headers']) => fetcher<GetFaqItemsQuery, GetFaqItemsQueryVariables>(GetFaqItemsDocument, variables, options);
export const GetTopQuestionsDocument = `
    query GetTopQuestions($questionIds: [ID!]!, $i18nLang: String!) {
  allFaqQuestion(
    limit: 3
    where: {_id: {in: $questionIds}, i18nLang: {eq: $i18nLang}, _: {is_draft: false}}
    sort: {priority: ASC}
  ) {
    name
    description
    slug {
      current
    }
  }
}
    `;
export const useGetTopQuestionsQuery = (variables, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== variables) {
    t0 = ["GetTopQuestions", variables];
    t1 = fetcher(GetTopQuestionsDocument, variables);
    $[0] = variables;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
useGetTopQuestionsQuery.getKey = (variables: GetTopQuestionsQueryVariables) => ['GetTopQuestions', variables];
useGetTopQuestionsQuery.fetcher = (variables: GetTopQuestionsQueryVariables, options?: RequestInit['headers']) => fetcher<GetTopQuestionsQuery, GetTopQuestionsQueryVariables>(GetTopQuestionsDocument, variables, options);